import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "messages", "userMessage" ]

  connect() {
    if (!this.hasMessagesTarget) return

    requestAnimationFrame(() => {
      this.scrollToLastUserMessage()
    })

    this.setupTimeout = setTimeout(() => {
      this.observer = new MutationObserver((mutations) => {
        const isFinished = this.messagesTarget.querySelector('[data-generation-finished="true"]')

        if (isFinished) {
          this.scrollToLastUserMessage()
        } else {
          this.scrollToBottom()
        }
      })

      this.observer.observe(this.messagesTarget, {
        childList: true,
        subtree: true,
        characterData: true
      })
    }, 200)
  }

  disconnect() {
    if (this.setupTimeout) {
      clearTimeout(this.setupTimeout)
    }

    if (this.observer) {
      this.observer.disconnect()
    }
  }

  scrollToLastUserMessage() {
    const userMessages = this.messagesTarget.querySelectorAll('.justify-end')
    const lastUser = userMessages[userMessages.length - 1]

    if (lastUser) {
      lastUser.scrollIntoView({
        behavior: 'instant',
        block: 'start'
      })
    }
  }

  scrollToBottom() {
    requestAnimationFrame(() => {
      this.messagesTarget.scrollTo({
        top: this.messagesTarget.scrollHeight,
        behavior: "instant"
      })
    })
  }

  resetForm(event) {
    if (event.detail.success) {
      event.target.reset();
    }

    const textarea = event.target.querySelector('textarea')
    if (textarea) {
      textarea.style.height = "auto";
      textarea.focus();
    }
  }
}
